import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import { createSelectionContext } from "../../selection/SelectionProvider";

export const {
  SelectionProvider: LoansSelectionProvider,
  useSelection: useLoansSelection,
} = createSelectionContext<HostSystemItemView>();
